export const MenuItems = [
    {
      title: "Home",
      url: "/",
      cName: "nav-links"
    },
    {
      title: "About",
      url: "/about",
      cName: "nav-links"
    },
    {
      title: "Programs",
      url: "/programs",
      cName: "nav-links"
    },
    {
      title: "Our Impact",
      url: "/impact",
      cName: "nav-links"
    },
    {
      title: "Contact",
      url: "/contact",
      cName: "nav-links"
    },
    {
      title: "Newsletter",
      url: "/newsletter",
      cName: "nav-links"
    }
  ];
  